import classNames from '@/lib/misc/classNames';
import { FaArrowLeft } from 'react-icons/fa6';
import { Button } from '@/components/ui/button';
import MobileMenu from '@/components/shared/MobileMenu';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import Image from 'next/image';
import { IoIosArrowBack } from 'react-icons/io';
export default function SwapFail({
  swapLoading,
  setIsConfirmationDialogOpen,
  quoteRefetch,
  setSwapResult,
  onClickBack
}) {
  const isMobile = useIsMobile();
  return <div className={classNames('h-[100vh] md:h-fit bg-genius-cream-foreground z-80 relative rounded-b-3xl', {
    invisible: swapLoading,
    visible: !swapLoading
  })} data-sentry-component="SwapFail" data-sentry-source-file="SwapFail.tsx">
      <div className='ta-c w-full m-auto max-w-[393px] text-genius-cream'>
        {isMobile ? <div className='w-full text-lg font-normal flex gap-x-2 ml-4 items-center justify-start text-genius-cream'>
            <Button type='button' variant='ghost' onClick={() => {
          setIsConfirmationDialogOpen(false);
          onClickBack && onClickBack();
        }} className='text-[14px] flex items-center bg-genius-blue rounded-full h-[31px] w-[74px] px-2'>
              <IoIosArrowBack className={`w-[16px] text-genius-cream`} width={20} height={18} />{' '}
              <p>Back</p>
            </Button>
          </div> : <></>}

        <div className='px-4 md:pt-2'>
          <Image className='mt-[20%] m-auto' alt='confirmation' src='/static/images/idea-error.png' width={56} height={56} data-sentry-element="Image" data-sentry-source-file="SwapFail.tsx" />

          <h1 className='font-normal text-[24px] text-genius-cream mt-10'>Oops, that’s on us.</h1>

          <p className='text-sm mt-4 text-genius-cream/50'>
            Your order failed to execute. Try Again Below
          </p>
        </div>
        <div className='fixed md:static bottom-[80px] w-[100%] w-full left-0 right-0 mx-auto justify-center ta-c px-2'>
          <Button onClick={() => {
          setSwapResult(null);
          quoteRefetch();
        }} variant='pink' className='py-7 rounded-full w-[100%] mx-auto mt-[30px] mb-1' data-sentry-element="Button" data-sentry-source-file="SwapFail.tsx">
            Try again
          </Button>

          <Button onClick={() => setIsConfirmationDialogOpen(false)} className='w-[100%] rounded-full py-7 text-genius-cream' variant='purple' data-sentry-element="Button" data-sentry-source-file="SwapFail.tsx">
            Change Order
          </Button>
        </div>
      </div>
      <MobileMenu data-sentry-element="MobileMenu" data-sentry-source-file="SwapFail.tsx" />
    </div>;
}